import { defineStore } from "pinia";
import axios from "@/lib/axios";

export const useLocationStore = defineStore("locations", {
    state: () => ({
        therapist_id: null,
        locations: [],
        selectedLocation: null,
        loading: false,
        currentTimestamp: Math.floor(Date.now() / 1000)
    }),

    actions: {
        fetchTherapistLocations: async function fetchTherapistLocations(therapistId = null) {
            this.loading = true;
            if (therapistId) {
                this.therapist_id = therapistId;
            }

            if (!this.therapist_id) {
                this.loading = false;
                console.error("No therapist ID provided, can't load locations");
                return;
            }

            try {
                const response = await axios("/server/api/locations", {
                    params: {
                        therapist_id: this.therapist_id
                    }
                });
                this.locations = response.data;
            } catch (error) {
                console.error("Failed to fetch locations:", new Error(error));
                this.locations = [];
            } finally {
                this.loading = false;
            }
        },

        fetchAllLocations: async function fetchAllLocations() {
            this.therapist_id = null;
            this.loading = true;

            try {
                const response = await axios("/server/api/locations");
                this.locations = response.data;
            } catch (error) {
                console.error("Failed to fetch locations:", new Error(error));
                this.locations = [];
                return [];
            } finally {
                this.loading = false;
            }

            return this.locations;
        },

        setSelectedLocation: function setSelectedLocation(location) {
            this.selectedLocation = location;
        },
    }
});
